export default "__VITE_ASSET__5bd2fb2b__"